import { analyticsDashboard as TYPES } from './../action_types';
import * as Ajax from './services';
import { dateParams as dateParamsUtil } from './utilities';

const fetch = function () {
  return function (dispatch, getState) {
    if (getState().AnalyticsDashboard.Downloads.meta.exhausted) return;
    if (getState().AnalyticsDashboard.Downloads.meta.fetching) return;

    dispatch({
      type: TYPES.FETCH_DOWNLOADS_REQUEST,
    });

    const dateParams = dateParamsUtil(
      getState().AnalyticsDashboard.DisplayedDates,
    );

    Ajax.DownloadsService(dateParams)
      .done(function (downloadsResponse) {
        dispatch({
          type: TYPES.FETCH_DOWNLOADS_SUCCESS,
          downloads: downloadsResponse.downloads,
        });
      })
      .fail(function () {
        dispatch({
          type: TYPES.FETCH_DOWNLOADS_FAILURE,
        });
      });
  };
};

const Downloads = {
  fetch: fetch,
};
export { Downloads };

const initialState = {
  models: [],
  meta: {
    exhausted: false,
    fetching: false,
  },
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case TYPES.FETCH_DOWNLOADS_REQUEST:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: true,
        }),
      });

    case TYPES.FETCH_DOWNLOADS_SUCCESS:
      return Object.assign({}, state, {
        models: state.models.concat(action.downloads),
        meta: Object.assign({}, state.meta, {
          fetching: false,
          exhausted: true,
          errorFetching: false,
        }),
      });

    case TYPES.FETCH_DOWNLOADS_FAILURE:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: false,
          errorFetching: true,
        }),
      });

    case TYPES.SET_DISPLAYED_DATES:
      return initialState;

    default:
      return state;
  }
};

export { reducer, reducer as default };
